
import { STA, INSTRUMENT_TEMPLATE, INSTRUMENT_INQUIRE, LAW_INQUIRE } from '../constants/statistics'
export const caseSort = [
  {
    title: '全部',
    expert_id: ''
  },
  {
    title: '离婚纠纷',
    expert_id: '7'
  },
  {
    title: '交通事故',
    expert_id: '12'
  },
  {
    title: '劳动纠纷',
    expert_id: '11'
  },
  {
    title: '借贷纠纷',
    expert_id: '10'
  },
  {
    title: '继承纠纷',
    expert_id: '8'
  },
  {
    title: '工伤赔偿',
    expert_id: '25'
  },
  {
    title: '房产纠纷',
    expert_id: '28'
  }
]

export const orgTypeName = {
  1: '司法鉴定机构',
  2: '人民调解委员会',
  3: '安置帮教',
  4: '司法所',
  5: '公证处',
  6: '法律服务所',
  7: '法律援助机构',
  8: '公共法律服务中心',
  10: '行政复议机构'
}

export const serviceList = {
  '0': {
    title: '人民调解',
    intro: '遇到纠纷矛盾该如何处理',
    desc: '自助进行人民调解查询，让调解员帮您解决问题',
    diagram: [{
      title: '在线申请',
      url: '/mediation/start',
      icon: 'icon_application',
      intro: '在线申请人民调解'
    },
    {
      title: '进度查询',
      url: '/mediation/applyInfo?url=/mediation/process',
      icon: 'icon_schedule',
      intro: '查询人民调解申请进度'
    },
    {
      title: '调解宣传',
      url: '/listone?id=594cc241cf33985dc9cc573f&title=调解宣传',
      icon: 'guide_mediation',
      intro: '了解人民调解办理事项'
    },
    {
      title: '法律法规',
      url: '/servicelaw/D9B5272ED3494ED496AD0D9D73559228/',
      icon: 'icon_law',
      intro: '查询相关法律法规 ',
      statistics: STA.MEDIATION_LAW
    },
    {
      title: '人民调解调委会',
      url: '/map/2?sort=distance',
      icon: 'map_mediation',
      intro: '查找附近人民调解委员会进行<br>咨询办理'
    },
    {
      title: '调解员查询',
      intro: '查找调解员',
      icon: 'icon_jd_people',
      url: '/mediation/tjpeople'
    },
    {
      title: '调解案例库',
      url: '/mediaion/case?id=5969b1c1cf3398068ddd270d&hasechild=1',
      icon: 'case_mediation',
      intro: '了解常见纠纷该如何解决'
    }
    ]
  },
  '2': {
    title: '公证服务',
    diagram: [{
      title: '办证指引',
      icon: 'guide_notarization',
      intro: '提前了解公证类别所需材料、费用',
      url: '/notarizationguide/case/add/5bea75e9e92c16492b23d437/?case_type=5&input_source=11'
    },
    {
      title: '在线申办',
      icon: 'icon_application',
      intro: '在线申请公证服务',
      url: '/notarization/apply'
    },
    {
      title: '法律法规',
      url: '/servicelaw/BE38AA9F79984918ACC679032CB49E01/',
      statistics: STA.NOTARY_LAW_INQUIRE,

      icon: 'icon_law',
      intro: '查询公证法律法规 '
    },
    {
      title: '公证处查询',
      intro: '查找附近公证机构进行办理',
      icon: 'map_notarization',
      url: '/map/5?sort=distance'
    }
    ]
  },
  '3': {
    title: '司法鉴定',
    diagram: [{
      title: '鉴定机构',
      icon: 'material_identify',
      intro: '按鉴定类别查询对应机构',
      url: '/identifyagency'
    },
    {
      title: '法律法规',
      url: '/servicelaw/0009B9E6BCAA427D82581145761B5D64/',
      statistics: STA.IDENTIFY_LAW_INQUIRE,
      icon: 'icon_law',
      intro: '查询司法鉴定法律法规 '
    },
    {
      title: '鉴定机构查询',
      intro: '查找附近鉴定机构进行咨询办理',
      icon: 'map_identify',
      url: '/map/1?sort=distance'
    },
    {
      title: '司法鉴定人员查询',
      intro: '查找司法鉴定人员',
      icon: 'icon_jd_people',
      url: '/jdpeople'
    }
    ]
  },
  '4': {
    title: '行政复议与应诉',
    diagram: [{
      title: '工作动态',
      icon: 'admin_review',
      intro: '行政复议工作动态',
      url: '/listone?id=5c9dcdca9748ca52072fa656&title=工作动态'
    },
    {
      title: '办事指南',
      icon: 'admin_guide',
      intro: '行政复议办事指南 ',
      url: '/listone?id=5cc10fb49748ca0224447857&title=办事指南'
    },
    {
      title: '法律法规',
      url: '/servicelaw/331A50D37213422FB2D16584DFBD9AD7/',
      statistics: STA.ADMINISTRATIVE_LAW,
      icon: 'icon_law',
      intro: '查询司法鉴定法律法规 '
    },
    ]
  },

  '6': {
    title: '法律援助',
    diagram: [{
      title: '资格预审、在线申请',
      icon: 'icon_application',
      url: '/legalaid/start',
      intro: '输入你的情况即可获得援助<br>资格预审,进行在线申请'
    },
    {
      title: '进度查询',
      icon: 'icon_schedule',
      url: '/legalaid/applyInfo?url=/legalaid/process',
      intro: '查询法律援助申请进度 '
    },
    {
      title: '法律法规',
      url: '/servicelaw/6767F3D3D6CB40D2BF74E22CDDCA1F95/',
      statistics: STA.LEGALAID_LAW,
      icon: 'icon_law',
      intro: '查询相关法律法规 '
    },
    {
      title: '援助须知',
      icon: 'guide_legalaid',
      url: '/listone?id=5950c748cf339815ba0efe31&title=援助须知',
      intro: '了解法律援助办理事项 '
    },
    {
      title: '法律援助机构',
      icon: 'map_legalaid',
      url: '/map/7?sort=distance',
      intro: '查找附近法律援助机构进行<br>咨询办理 '
    }
    ]
  },
  '7': {
    title: '乡村振兴法律服务',
    diagram: [{
      title: '政策法规',
      icon: 'support_law',
      intro: ' 政策法规',
      url: '/ruralLaw'
    },

    {
      title: '乡村振兴动态',
      intro: '乡村振兴政策动态',
      icon: 'support_news',
      url: '/listone?id=61304a8c0c4886185ed79f0f&title=乡村振兴动态'
    },
    {
      title: '“万千万”法律服务',
      intro: '助推乡村振兴专项活动',
      icon: 'support_service',
      url: '/listone?id=5b65424fe92c167b46801765&title=万千万法律服务&minority=true'
    }
    ]
  },
  '8': {
    title: '少数民族法规',
    diagram: [{
      title: '苗族',
      intro: '',
      icon: 'minority-miao',
      url: '/listone?id=5afe50bfcf33984ba6a37636&title=苗族&minority=9&post=post'
    },
    {
      title: '壮族',
      intro: '',
      icon: 'minority-zhuang',
      url: '/listone?id=5afe50dccf33984ba6a37643&title=壮族&minority=9&post=post'

    },
    {
      title: '哈尼族',
      intro: '',
      icon: 'minority-hani',
      url: '/listone?id=5afe50f1cf33984ba764c1dc&title=哈尼族&minority=9&post=post'

    },
    {
      title: '彝族',
      intro: '',
      icon: 'minority-yi',
      url: '/listone?id=5afe5102cf33984ba6a37657&title=彝族&minority=9&post=post'
    },
    {
      title: '藏族',
      intro: '',
      icon: 'minority-zang',
      url: '/listone?id=5df885379748ca3e499c5b03&title=彝族&minority=9&post=post'
    }
    ]
  },
  '9': {
    title: '一带一路服务',
    diagram: [{
      title: '中国法规',
      intro: '南亚、东南亚各国翻译版',
      icon: 'chineseLaw',
      url: '/onewaylaw'
    },
    {
      title: '南亚、东南亚法律法规',
      intro: '中文翻译版',
      icon: 'southEastenLaw',
      url: '/foreign'
    },
    {
      title: '云南律师事务所',
      intro: '驻南亚、东南亚分所',
      icon: 'lawfirm',
      url: '/listone?id=5b02897ecf339837599c91f3&title=律师事务所'
    },
    {
      title: '法律服务案例库',
      intro: '',
      slogan: '一带一路',
      icon: 'case',
      url: '/listone?id=5b0293c6cf33986252eef0ee&title=法律服务案例库'
    },
    {
      title: '实用指南',
      intro: '',
      slogan: '一带一路',
      icon: 'guide',
      url: '/listone?id=5b3cdcf6cf33983a213d52c9&title=实用指南'
    }
    ]
  },
  '10': {
    title: '留言咨询',
    diagram: [{
      title: '新建留言咨询',
      icon: 'meaasge_add',
      url: '/advisory/message/start'
    },
    {
      title: '留言咨询查询',
      icon: 'message_list',
      url: '/advisory/message/info?url=/advisory/message/list'
    }]
  },
  '11': {
    title: '法律文书模板',
    diagram: [
      {
        title: '在线生成文书',
        icon: 'online_document',
        aiurl: '/terminal/instrument',
        intro: '根据系统问题填写文书内容自动生成完整文书',
        statistics: INSTRUMENT_INQUIRE
      },
      {
        title: '合同文书模板',
        icon: 'contract_document',
        aiurl: '/terminal/doclist',
        intro: '提供格式合同、文书模板、供你参考使用',
        statistics: INSTRUMENT_TEMPLATE
      }
    ]
  },
  '12': {
    title: '查询服务',
    diagram: [
      {
        title: '机构查询',
        icon: 'execution_search',
        url: '/map'
      },
      {
        title: '法律法规查询 ',
        aiurl: '/cus/law-ter/law',
        icon: 'icon_law',
        statistics: LAW_INQUIRE
      }
    ]
  },
  '13': {
    title: '仲裁服务',
    diagram: [
      {
        title: '仲裁指南',
        icon: 'guide_mediation',
        url: '/listone?id=5e7c0d5f9748ca3efb2de4fb&title=仲裁指南',

      },
      {
        title: '法律法规',
        url: '/servicelaw/D7E0851C9C2B46F4BCDFB62323EDD14A',
        icon: 'icon_law',
        statistics: STA.ARBITRATION_LAW
      }
    ]
  },
  fuyi: {
    title: '行政复议',
    diagram: [
      {
        title: '工作动态',
        icon: 'support_news',
        url: '/listone?id=68a44d037edc0105c568bb81&title=工作动态',

      },
      {
        title: '复议指南',
        icon: 'guide_mediation',
        url: '/listone?id=68a44cf57edc0105ca83399e&title=复议指南',

      },
      {
        title: '法律法规',
        url: '/listone?id=68a44d187edc0105bf03bd95&title=法律法规',
        icon: 'icon_law',
      },
      {
        title: '典型案例',
        url: '/listone?id=68a44d0c7edc0105bf03bd55&title=典型案例',
        icon: 'case',
      },
      {
        title: '行政复议网上申请',
        url: '/post/68abd6297edc015263489405?title=行政复议网上申请',
        icon: 'admin_apply',
      },
      {
        title: '行政复议机构',
        icon: 'fuyi',
        url: '/map/10?sort=distance',
      },

    ]
  }
}

export const nations = [
  {
    label: '汉族',
    value: '汉族',
    code: '01'
  },
  {
    label: '蒙古族',
    value: '蒙古族',
    code: '02'
  },
  {
    label: '回族',
    value: '回族',
    code: '03'
  },
  {
    label: '藏族',
    value: '藏族',
    code: '04'
  },
  {
    label: '维吾尔族',
    value: '维吾尔族',
    code: '05'
  },
  {
    label: '苗族',
    value: '苗族',
    code: '06'
  },
  {
    label: '彝族',
    value: '彝族',
    code: '07'
  },
  {
    label: '壮族',
    value: '壮族',
    code: '08'
  },
  {
    label: '布依族',
    value: '布依族',
    code: '09'
  },
  {
    label: '朝鲜族',
    value: '朝鲜族',
    code: '10'
  },
  {
    label: '满族',
    value: '满族',
    code: '11'
  },
  {
    label: '侗族',
    value: '侗族',
    code: '12'
  },
  {
    label: '瑶族',
    value: '瑶族',
    code: '13'
  },
  {
    label: '白族',
    value: '白族',
    code: '14'
  },
  {
    label: '土家族',
    value: '土家族',
    code: '15'
  },
  {
    label: '哈尼族',
    value: '哈尼族',
    code: '16'
  },
  {
    label: '哈萨克族',
    value: '哈萨克族',
    code: '17'
  },
  {
    label: '傣族',
    value: '傣族',
    code: '18'
  },
  {
    label: '黎族',
    value: '黎族',
    code: '19'
  },
  {
    label: '傈僳族',
    value: '傈僳族',
    code: '20'
  },
  {
    label: '佤族',
    value: '佤族',
    code: '21'
  },
  {
    label: '畲族',
    value: '畲族',
    code: '22'
  },
  {
    label: '高山族',
    value: '高山族',
    code: '23'
  },
  {
    label: '拉祜族',
    value: '拉祜族',
    code: '24'
  },
  {
    label: '水族',
    value: '水族',
    code: '25'
  },
  {
    label: '东乡族',
    value: '东乡族',
    code: '26'
  },
  {
    label: '纳西族',
    value: '纳西族',
    code: '27'
  },
  {
    label: '景颇族',
    value: '景颇族',
    code: '28'
  },
  {
    label: '柯尔克孜族',
    value: '柯尔克孜族',
    code: '29'
  },
  {
    label: '土族',
    value: '土族',
    code: '30'
  },
  {
    label: '达斡尔族',
    value: '达斡尔族',
    code: '31'
  },
  {
    label: '仫佬族',
    value: '仫佬族',
    code: '32'
  },
  {
    label: '羌族',
    value: '羌族',
    code: '33'
  },
  {
    label: '布朗族',
    value: '布朗族',
    code: '34'
  },
  {
    label: '撒拉族',
    value: '撒拉族',
    code: '35'
  },
  {
    label: '毛南族',
    value: '毛南族',
    code: '36'
  },
  {
    label: '仡佬族',
    value: '仡佬族',
    code: '37'
  },
  {
    label: '锡伯族',
    value: '锡伯族',
    code: '38'
  },
  {
    label: '阿昌族',
    value: '阿昌族',
    code: '39'
  },
  {
    label: '普米族',
    value: '普米族',
    code: '40'
  },
  {
    label: '塔吉克族',
    value: '塔吉克族',
    code: '41'
  },
  {
    label: '怒族',
    value: '怒族',
    code: '42'
  },
  {
    label: '乌孜别克族',
    value: '乌孜别克族',
    code: '43'
  },
  {
    label: '俄罗斯族',
    value: '俄罗斯族',
    code: '44'
  },
  {
    label: '鄂温克族',
    value: '鄂温克族',
    code: '45'
  },
  {
    label: '德昂族',
    value: '德昂族',
    code: '46'
  },
  {
    label: '保安族',
    value: '保安族',
    code: '47'
  },
  {
    label: '裕固族',
    value: '裕固族',
    code: '48'
  },
  {
    label: '京族',
    value: '京族',
    code: '49'
  },
  {
    label: '塔塔尔族',
    value: '塔塔尔族',
    code: '50'
  },
  {
    label: '独龙族',
    value: '独龙族',
    code: '51'
  },
  {
    label: '鄂伦春族',
    value: '鄂伦春族',
    code: '52'
  },
  {
    label: '赫哲族',
    value: '赫哲族',
    code: '53'
  },
  {
    label: '门巴族',
    value: '门巴族',
    code: '54'
  },
  {
    label: '珞巴族',
    value: '珞巴族',
    code: '55'
  },
  {
    label: '基诺族',
    value: '基诺族',
    code: '56'
  }
]

export const disputeList = {
  0: '全部',
  1: '医疗纠纷',
  2: '劳动争议',
  3: '道路交通',
  4: '物业纠纷',
  5: '妇女儿童权益',
  6: '其他'
}




export const residence = {
  530100: '昆明市',
  530102: '五华区',
  530103: '盘龙区',
  530111: '官渡区',
  530112: '西山区',
  530113: '东川区',
  530114: '呈贡区',
  530122: '晋宁区',
  530124: '富民县',
  530125: '宜良县',
  530126: '石林县',
  530127: '嵩明县',
  530128: '禄劝县',
  530129: '寻甸县',
  530181: '安宁市'
}

export const mapslist = [
  {
    icon: 'iconfalvyuanzhugongzuozhan',
    title: '法律援助机构',
    color: '#e55158',
    url: '/map/7',
  },
  {
    icon: 'icontiaoweihuichaxun',
    title: '人民调解委员会',
    color: '#8f81e2',
    url: '/map/2',
  },
  {
    icon: 'iconfalvfuwusuo',
    title: '法律服务所',
    color: '#3574e5',
    url: '/map/6',
  },
  {
    icon: 'iconfayuan',
    title: '司法所',
    color: '#e3bf6b',
    url: '/map/4',
  },
  {
    icon: 'icongongzhengchu',
    title: '公证处',
    url: '/map/5',
    color: '#6fb8a7'
  },
  {
    icon: 'iconsifajianding',
    title: '司法鉴定机构',
    color: '#a07bbc',
    url: '/map/1',
  },
  {
    icon: 'iconzhongcai',
    title: '仲裁机构',
    color: '#e55158',
    url: '/map/9',
  },
  {
    icon: 'icongonggongfalvfuwuzhongxin',
    title: '公共法律服务中心',
    color: '#33c339',
    url: '/map/8',
  },
  {
    icon: 'iconlvshi',
    title: '律师查询',
    color: '#4c89f8',
    url: '/flsearch/1'
  },
  {
    icon: 'iconlvsuochaxun',
    title: '律所查询',
    color: '#fc9d0b',
    url: '/flsearch/2'
  },
  {
    icon: 'iconsifajiandingrenyuanchaxun',
    title: '司法鉴定人员查询',
    color: '#4c89f8',
    url: '/jdpeople'
  },
  {
    title: '行政复议机构',
    icon: 'iconhangzhengfuyi',
    color: '#e55158',
    url: '/map/10',
  }
]



// 机构导航类型
export const organtype = [
  // { title: '法院', icon: 'icon-lawfirm', type: 1 },
  // { title: '律所', icon: 'icon-lawfirm', type: 2 },
  {
    title: '公证处',
    icon: 'icon-notarization-agency--v2',
    type: 3
  },
  {
    title: '法律援助',
    icon: 'icon-legalaid',
    type: 4
  },
  {
    title: '司法鉴定',
    icon: 'icon-identify',
    type: 5
  },
  {
    title: '人民调解',
    icon: 'icon-mediation',
    type: 6
  },
  // { title: '安置帮教', icon: 'icon-mediation', type: 7 },
  {
    title: '司法所',
    icon: 'icon-mediation',
    type: 8
  },
  {
    title: '服务所',
    icon: 'icon-mediation',
    type: 9
  }
]

export const suggesType = [
  '法律援助',
  '人民调解',
  '司法鉴定',
  '公证',
  '律所律师',
  '其他建议'
]

